import Vue from 'vue'
import Router from 'vue-router'
import WxAuth from '@/views/wxAuth' // 授权页
import NotFound from '@/views/404' // 404
import Login from '@/views/user/login' // 登录页
import Agreement from '@/views/user/agreement' // 用户协议页
import AgreementDabenying from '@/views/user/agreement-dabenying' // 用户协议页
import AgreementBopeng from '@/views/user/agreement-bopeng' // 用户协议页
import AgreementJiajiuhui from '@/views/user/agreement-jiajiuhui' // 用户协议页
import AgreementBoxing from '@/views/user/agreement-boxing' // 用户协议页
import AgreementFuqi from '@/views/user/agreement-fuqi' // 用户协议页
import AgreementBeifu from '@/views/user/agreement-beifu' // 用户协议页
import AgreementCehao from '@/views/user/agreement-cehao' // 用户协议页
import AgreementBaoleqi from '@/views/user/agreement-baoleqi' // 用户协议页
import Remind from '@/views/user/remind' // 签署合同提示说明页
import UserCenter from '@/views/user/userCenter' // 用户中心
import Robbing from '@/views/robbing/robbing' // 抢购页面
import OrderList from '@/views/robbing/orderList' // 支付记录
import DeliveryList from '@/views/inventory/deliveryList' // 提货记录
import LogisticsRecord from '@/views/inventory/logisticsRecord' // 物流记录
import Inventory from '@/views/inventory/inventory' // 我的库存
import Delivery from '@/views/inventory/delivery' // 提货
import AddressList from '@/views/address/addressList' // 地址列表管理
import EditAddress from '@/views/address/editAddress' // 创建，编辑地址
import Maintain from '@/views/maintain' // 系统维护页面

Vue.use(Router)

var router = new Router({
  routes: [{
    path: '/',
    redirect: '/robbing'
  }, {
    path: '*',
    redirect: '/404'
  }, {
    path: '/404',
    name: '404',
    component: NotFound
  }, {
    path: '/wxAuth',
    name: 'wxAuth',
    meta: {
      title: '授权'
    },
    component: WxAuth
  }, {
    path: '/login',
    name: 'login',
    meta: {
      title: '胶原蛋白弹性蛋白饮料'
    },
    component: Login
  }, {
    path: '/agreement',
    name: 'agreement',
    meta: {
      title: '用户服务协议'
    },
    component: Agreement
  }, {
    path: '/agreement-dabenying',
    name: 'agreement-dabenying',
    meta: {
      title: '用户服务协议'
    },
    component: AgreementDabenying
  }, {
    path: '/agreement-bopeng',
    name: 'agreement-bopeng',
    meta: {
      title: '用户服务协议'
    },
    component: AgreementBopeng
  }, {
    path: '/agreement-jiajiuhui',
    name: 'agreement-jiajiuhui',
    meta: {
      title: '用户服务协议'
    },
    component: AgreementJiajiuhui
  }, {
    path: '/agreement-boxing',
    name: 'agreement-boxing',
    meta: {
      title: '用户服务协议'
    },
    component: AgreementBoxing
  }, {
    path: '/agreement-fuqi',
    name: 'agreement-fuqi',
    meta: {
      title: '用户服务协议'
    },
    component: AgreementFuqi
  }, {
    path: '/agreement-beifu',
    name: 'agreement-beifu',
    meta: {
      title: '用户服务协议'
    },
    component: AgreementBeifu
  }, {
    path: '/agreement-cehao',
    name: 'agreement-cehao',
    meta: {
      title: '用户服务协议'
    },
    component: AgreementCehao
  }, {
    path: '/agreement-baoleqi',
    name: 'agreement-baoleqi',
    meta: {
      title: '用户服务协议'
    },
    component: AgreementBaoleqi
  }, {
    path: '/remind',
    name: 'remind',
    meta: {
      title: '合同签署'
    },
    component: Remind
  }, {
    path: '/userCenter',
    name: 'userCenter',
    meta: {
      title: '个人中心'
    },
    component: UserCenter
  }, {
    path: '/robbing',
    name: 'robbing',
    meta: {
      title: '胶原蛋白弹性蛋白饮料'
    },
    component: Robbing
  }, {
    path: '/orderList',
    name: 'orderList',
    meta: {
      title: '支付记录'
    },
    component: OrderList
  }, {
    path: '/deliveryList',
    name: 'deliveryList',
    meta: {
      title: '提货记录'
    },
    component: DeliveryList
  }, {
    path: '/logisticsRecord',
    name: 'logisticsRecord',
    meta: {
      title: '物流记录'
    },
    component: LogisticsRecord
  }, {
    path: '/inventory',
    name: 'inventory',
    meta: {
      title: '我的库存'
    },
    component: Inventory
  }, {
    path: '/delivery',
    name: 'delivery',
    meta: {
      title: '提货'
    },
    component: Delivery
  }, {
    path: '/addressList',
    name: 'addressList',
    meta: {
      title: '地址管理'
    },
    component: AddressList
  }, {
    path: '/editAddress',
    name: 'editAddress',
    meta: {
      title: '编辑地址'
    },
    component: EditAddress
  }, {
    path: '/maintain',
    name: 'maintain',
    meta: {
      title: '温馨提示'
    },
    component: Maintain
  }],
  scrollBehavior() {
    // 让每个页面打开后滚动到顶部
    return {
      x: 0,
      y: 0
    }
  }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/routers.js